import React, { ReactChild } from 'react';

import clsx from 'clsx';

import {
  Message,
  Container,
  IconType,
  Icon,
  Link,
  LinkProps,
  Text,
  H1,
} from '@atoms';

import { types } from './header.types';

import classes from './header.module.scss';

type Props = {
  type?: keyof typeof types;
  title: Message;
  subtitle?: Message;
  cta?: ReactChild;
  backgroundUrl?: string;
  backgroundClassName?: string;
  backgroundOverlay?: boolean;
  bottom?: ReactChild;
  arrowBack?: {
    icon: IconType;
    message: Message;
    linkProps: Omit<LinkProps, 'children' | 'classes'>;
  };
};

const heroTypes: Props['type'][] = [types['hero-tight']];

export const Header = ({
  type = types.normal,
  title,
  subtitle,
  cta,
  backgroundUrl,
  backgroundClassName,
  backgroundOverlay = false,
  bottom,
  arrowBack,
}: Props) => {
  return (
    <header
      className={clsx(
        classes.header,
        type === types['hero-tight'] && classes.tight,
        type === types.normal && classes.normal,
      )}
    >
      {arrowBack && (
        <Container className={classes.arrowBack}>
          <Link {...arrowBack.linkProps}>
            <span className={classes.content}>
              <Icon
                icon={arrowBack.icon}
                color="white"
                className={classes.icon}
              />
              {/* TITLE */}
              <Text type="reduced" message={arrowBack.message} color="white" />
            </span>
          </Link>
        </Container>
      )}
      {/* CONTENT */}
      <Container className={classes.container}>
        <div className={classes.content}>
          <H1
            message={title}
            color={backgroundOverlay ? 'white' : 'big_stone'}
            textAlign="center"
            className={classes.title}
          />
          {/* SUBTITLE */}
          {subtitle && (
            <Text
              type={type === types.normal ? 'regular' : 'h4'}
              message={subtitle}
              textAlign="center"
              className={clsx(classes.subtitle)}
            />
          )}
          {/* CTA */}
          {cta && <div className={clsx(classes.ctaContainer)}>{cta}</div>}
        </div>
      </Container>
      {/* BACKGROUND */}
      {heroTypes.includes(type) && [
        <div
          className={clsx(classes.background, backgroundClassName)}
          style={{
            backgroundImage: backgroundUrl
              ? `url(${backgroundUrl})`
              : undefined,
          }}
          key="b"
        />,
        backgroundOverlay && (
          <div className={classes.backgroundOverlay} key="o" />
        ),
      ]}
      {/* BOTTOM */}
      <div className={classes.bottom}>{bottom}</div>
    </header>
  );
};
